import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { RaisedButton } from 'material-ui';

import { BlockWrapper } from '../../common/BlockWrapper';
import { formName } from 'data/formNames';
import './ServiceProviders.scss';
import ServiceProvidersApproval from './ServiceProvidersApproval/Component';
import ServiceProvidersView from './ServiceProvidersView/ServiceProvidersView';

export const IsEditModeOnContext = React.createContext(false);

const ServiceProvidersManagement = ({
    port,
    onApproveField,
    onRejectField,
    serviceProviders,
    onSaveChanges,
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [portServiceProviders, setPortServiceProviders] = useState(port.serviceProviders);

    useEffect(() => {
        setPortServiceProviders(port.serviceProviders);
    }, [port.serviceProviders]);

    const resetServiceProviders = () => {
        setPortServiceProviders(port.serviceProviders);
    };
    
    const cancelEdit = () => {
        setIsEditing(false);
        resetServiceProviders();
    };

    const hasChanges = 
        serviceProviders && serviceProviders.find(s => ['change', 'new', 'remove'].includes(s.status));

    const saveChanges = async () => {
        onSaveChanges(portServiceProviders, () => {
            setIsEditing(false);
        });
    };

    if (hasChanges) {
        return (
            <BlockWrapper title="Service Providers">
                <ServiceProvidersApproval 
                    serviceProviders={serviceProviders}
                    rejectServiceProvider={onRejectField}
                    approveServiceProvider={onApproveField}
                />
            </BlockWrapper>
        );
    }

    return (
        <BlockWrapper title="Service Providers">
            <IsEditModeOnContext.Provider value={isEditing}>
                <ServiceProvidersView 
                    serviceProviders={portServiceProviders} 
                    updateServiceProviders={setPortServiceProviders} 
                    resetServiceProviders={resetServiceProviders}
                />
                {
                    isEditing ?
                        <div className="form-actions">
                            <RaisedButton
                                label="Save Changes"
                                primary
                                onClick={saveChanges}
                            />
                            <RaisedButton
                                label="Cancel"
                                secondary
                                onClick={cancelEdit}
                                style={{ marginRight: '10px' }}
                            />
                        </div> :
                        <div className="form-actions">
                            <RaisedButton
                                label="Edit Service Providers"
                                onClick={() => setIsEditing(true)}
                                primary
                            />
                        </div>
                }
            </IsEditModeOnContext.Provider>
        </BlockWrapper>
    );
};

ServiceProvidersManagement.propTypes = {
    port: PropTypes.shape({
        serviceProviders: PropTypes.array,
    }).isRequired,
    onApproveField: PropTypes.func.isRequired,
    onRejectField: PropTypes.func.isRequired,
    serviceProviders: PropTypes.array,
};

reduxForm({
    form: formName.portUpdate,
    enableReinitialize: true,
})(ServiceProvidersManagement);

export default ServiceProvidersManagement;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProviders.jsx